// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export interface UserDefinition {
  /** The id of the user. */
  id?: string;
}
